import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";

interface ConfirmDialogProps {
  open: boolean;
  title?: string;
  message?: string;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title = "Are you sure?",
  message,
  onClose,
  onConfirm
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle component="div" sx={{ fontWeight: 600, color: "#1F497D" }}>
      {title}
    </DialogTitle>
    {message && (
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
    )}
    <DialogActions sx={{ p: 2 }}>
      <Button onClick={onClose} color="inherit">
        Cancel
      </Button>
      <Button color="error" variant="contained" onClick={onConfirm} sx={{ textTransform: "none" }}>
        Confirm
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDialog;

